import React from "react";
import { Form, Input, message } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Button } from "Components/General/Button";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";

export interface RestoreModalProps extends WithTranslation, ModalComponentProps {
  restoreFiles: (filesToRestore: API_FileDataEntity[], reason: string) => void;
  files: API_FileDataEntity[];
}

export const RestoreModal = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<RestoreModalProps> {

    onCancel = () => {
      const { hideModal } = this.props;
      hideModal();
    };

    onFinish = (values) => {
      const { t, restoreFiles, files, hideModal } = this.props;
      restoreFiles(files, values.reason);
      message.success(t("Success"));
      hideModal();
    };

    render() {
      const { t } = this.props;
      return (
        <>
          <Form requiredMark={true} onFinish={this.onFinish}>
            <Form.Item
              rules={[{ required: true, message: t("Please provide a reason for reactivation of this file") }]}
              label={t("Reason")}
              name="reason"
            >
              <Input.TextArea allowClear={true} autoFocus={true} />
            </Form.Item>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
              <Button style={{ marginRight: 10 }} onClick={this.onCancel}>
                {t("Cancel")}
              </Button>
              <Button htmlType="submit" type="primary">
                {t("Save")}
              </Button>
            </div>
          </Form>
        </>
      );
    }
  }
);
